/**
 * @description
 */

import './sectionParagraph.scss';

import React, { Component } from 'react';
import { getData } from '@umu/umu-util';
import SimditorText from '../@simditorText/simditorText';

import {
    ESectionType,
    ISectionBaseInfo,
    ISectionOptionBaseInfo,
    ISectionBaseExtend,
    ISectionBaseSetup,
} from '@umu/umu-types';

export interface IProps<IType, IOption, IExtend> {
    sectionInfo: ISectionBaseInfo<IType, IOption, IExtend>;
}

export default class SectionParagraph extends Component<
    IProps<ESectionType, ISectionOptionBaseInfo, ISectionBaseExtend<ISectionBaseSetup>>
> {
    constructor(props: IProps<ESectionType, ISectionOptionBaseInfo, ISectionBaseExtend<ISectionBaseSetup>>) {
        super(props);
    }

    public render() {
        const { title, desc, extend } = this.props.sectionInfo;
        const resourceArr = getData(extend, 'resource_arr');
        let multimediaId;
        if (Array.isArray(resourceArr) && resourceArr[0]) {
            multimediaId = resourceArr[0].resource_id.toString();
        }
        return (
            <div className="section-paragraph">
                <div className="section-paragraph-wrap">
                    <div className="option-icon">
                        <div className="icon"></div>
                    </div>
                    <div className="option-content">
                        <SimditorText multimediaId={multimediaId} cnt={title || desc} />
                    </div>
                </div>
            </div>
        );
    }
}
